module.exports = __webpack_public_path__ + "static/media/card-logo-4.32567ee6.svg";